import styled from 'styled-components'

const WorkspaceStatisticsPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export default WorkspaceStatisticsPanelContainer
